import React from 'react';
import { connect } from 'react-redux';
import { Modal, Text, Button, i18n, tokens } from '@simplybenefits/sb-ui-library';
import { numberWithCommas } from "../../../services/helpers";
import { useLottie } from "lottie-react";
import checkMarkConfetti from "../../../assets/check-mark-confetti.json";

/**
 * This is the check mark animation component which uses the lottie-react library
 */
const CheckMarkAnimation = () => {
    const options = {
        animationData: checkMarkConfetti,
        loop: true
    };

    const { View } = useLottie(options);

    return (
        <div 
            style={{
                height: 350,
                marginTop: -60,
                marginBottom: 10
            }}
        >
            { View }
        </div>
    );
};

/**
 *
 * @param {*} param0
 */
const ClaimSuccessModal = ({ amountClaimed, patient, onClose, uid }) => (
    <Modal open={true}>
        <CheckMarkAnimation/>

        <Text
            align={"center"}
            display="block"
            large
            bold
        >
            { i18n.t(tokens.labels.claims.claimCompleted) }
        </Text>

        <Text
            align={"center"}
            display="block"
            margin="10px 0 0 0"
            medium
        >
            { i18n.t(tokens.labels.claims.claimDetails, { amountClaimed: numberWithCommas(amountClaimed), patient: patient })}
        </Text>

        <div 
            style={{ 
                display: "flex", 
                flexDirection: "row",
                justifyContent: "center",
                marginTop: 30,
                marginBottom: 30
            }}
        >
            <Text
                align={"center"}
                display="block"
                medium
                customStyle={{ marginRight: 10 }}
            >
                { i18n.t(tokens.labels.claims.claimIdentifier, { uid: " " }) }
            </Text>

            <Text
                align={"center"}
                display="block"
                medium
                bold
            >
                { uid }
            </Text>
        </div>

        <Button 
            onClick={onClose}
            color={"primary"}
            customStyle={{ 
                alignSelf: "center", 
                width: "100%",
                marginTop: 2
            }}
        >
            { i18n.t(tokens.buttons.done) }
        </Button>
    </Modal>
);

export default connect()(ClaimSuccessModal);